/* Fetch data from Creek /tracks API */

const events = require('../core/events');
const fetch = require('../helpers/fetch');

const currentTrackUrl = '/api/tracks/current';

const tracks = {
  fetchCurrent: function fetchCurrent() {
    fetch.get(currentTrackUrl, { responseType: 'json' }, {
      success: function gotCurrentTrack(response) {
        document.dispatchEvent(new CustomEvent(events.dataCurrentTrackInfo, {
          detail: response
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  }
};

module.exports = tracks;



//////////////////
// WEBPACK FOOTER
// ./src/js/data/creekTracksApi.js
// module id = 118
// module chunks = 1